import { render, staticRenderFns } from "./ActiveFiltersList.vue?vue&type=template&id=023e5d2a&scoped=true"
import script from "./ActiveFiltersList.vue?vue&type=script&lang=js"
export * from "./ActiveFiltersList.vue?vue&type=script&lang=js"
import style0 from "./ActiveFiltersList.vue?vue&type=style&index=0&id=023e5d2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023e5d2a",
  null
  
)

export default component.exports